"use client";

import { useEffect, useRef } from "react";

export function AdSenseBanner({
  id,
  slot,
  height,
}: {
  id: string;
  slot: string;
  height: number;
}) {
  const adRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (process.env.NODE_ENV !== "production") return;
    loadAd();

    let resizeTimeout: ReturnType<typeof setTimeout> | null = null;
    let lastWidth = window.innerWidth;

    const handleResize = () => {
      const currentWidth = window.innerWidth;
      if (currentWidth === lastWidth) return;
      lastWidth = currentWidth;

      if (resizeTimeout) clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => loadAd(), 500);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
      if (resizeTimeout) clearTimeout(resizeTimeout);
    };
  }, [id, slot, height]);

  const loadAd = () => {
    const container = adRef.current;
    if (!container) return;

    container.innerHTML = "";

    const ins = document.createElement("ins");
    ins.className = "adsbygoogle";
    ins.style.display = "inline-block";
    ins.style.width = "100%";
    ins.style.height = `${height}px`;
    ins.style.maxHeight = `${height}px`;
    ins.setAttribute("data-ad-client", "ca-pub-6653791084583982");
    ins.setAttribute("data-ad-slot", slot);
    ins.setAttribute("data-full-width-responsive", "false");

    container.appendChild(ins);

    try {
      (window as unknown as { adsbygoogle?: unknown[] }).adsbygoogle =
        (window as unknown as { adsbygoogle?: unknown[] }).adsbygoogle || [];
      (window as unknown as { adsbygoogle: unknown[] }).adsbygoogle.push({});
    } catch (e) {
      console.error(e);
    }
  };

  if (process.env.NODE_ENV !== "production") {
    return (
      <div
        style={{
          background: "#e9e9e9",
          display: "inline-block",
          fontSize: "14px",
          fontWeight: "bold",
          textAlign: "center",
          width: "100%",
          height: `${height}px`,
          maxHeight: `${height}px`,
        }}
      >
        <div
          style={{
            width: "100%",
            height: `${height}px`,
            maxHeight: `${height}px`,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "14px",
            fontWeight: "bold",
            textAlign: "center",
            color: "#6d6d6d",
          }}
        >
          광고 영역 - {id}
        </div>
      </div>
    );
  }

  return (
    <div
      ref={adRef}
      className="text-center"
      style={{ minHeight: `${height}px` }}
    />
  );
}
